(() => {
  if (window.cfProductCardsInstalled) return;
  window.cfProductCardsInstalled = true;

  // Representative finish colors; configured colors always take priority.
  const colorMap = {
    white: '#FFFFFF', ivory: '#FFFFF0', cream: '#FFF2D5', offwhite: '#F5F2E9',
    black: '#000000', charcoal: '#414141', gray: '#808080', grey: '#808080',
    silver: '#C0C0C0', chrome: '#C0C0C0', platinum: '#D8D8D8',
    gold: '#D4AF37', brass: '#B5A642', bronze: '#A97142', champagne: '#E7D2AC',
    pink: '#E8B4C2', blush: '#E8B4B8', rose: '#C98792', mauve: '#B58B9A',
    red: '#B5222B', burgundy: '#800020', maroon: '#800000', rust: '#A64B2A',
    blue: '#2868A0', navy: '#172B4D', teal: '#008080', turquoise: '#40B5AD',
    green: '#4B7043', sage: '#A3B18A', olive: '#808000', emerald: '#287850',
    purple: '#800080', lavender: '#B7A0CC', plum: '#673D60',
    yellow: '#EACB36', mustard: '#C8A329', orange: '#D97930',
    brown: '#795548', walnut: '#6B4A32', espresso: '#3C2822', chocolate: '#5B3826',
    oak: '#BA9466', natural: '#C8AA7D', cherry: '#854735', mahogany: '#6E3028',
    beige: '#D6C5A6', tan: '#D2B48C', taupe: '#9B8B7A', sand: '#D6C3A3',
    camel: '#C19A6B', cognac: '#A86432', caramel: '#B47B48',
    blanco: '#FFFFFF', negro: '#000000', gris: '#808080', rosa: '#E8B4C2',
    azul: '#2868A0', verde: '#4B7043', rojo: '#B5222B', morado: '#800080',
    amarillo: '#EACB36', cafe: '#795548', nogal: '#6B4A32'
  };
  function validColor(value) {
    if (!value) return false;
    if (/^(transparent|inherit|initial|unset|revert|currentcolor)$/i.test(value)) return false;
    if (/var\(|env\(/i.test(value)) return false;
    return CSS.supports('color', value);
  }
  function nameColor(name) {
    const normalized = name.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    const compact = normalized.replace(/[\s-]+/g, '');
    if (colorMap[compact]) return colorMap[compact];
    // For finishes such as White/Chrome, use the first recognized color.
    const words = normalized.split(/[^a-z]+/);
    for (const word of words) if (colorMap[word]) return colorMap[word];
    return '';
  }
  function paintSwatches(root = document) {
    root.querySelectorAll('.cf-color-swatch:not([data-cf-painted])').forEach(swatch => {
      swatch.dataset.cfPainted = 'true';
      swatch.style.backgroundImage = 'none';
      swatch.replaceChildren();
      let color = (swatch.dataset.swatchColor || '').trim();
      if (/^(?:[0-9a-f]{3}|[0-9a-f]{6})$/i.test(color)) color = '#' + color;
      if (!validColor(color)) color = nameColor(swatch.dataset.colorName || '');
      if (validColor(color)) {
        swatch.style.backgroundColor = color;
        swatch.classList.add('cf-has-color');
      } else {
        // Do not display a blank square or invent an unidentified color.
        swatch.style.display = 'none';
        swatch.dataset.cfUnresolved = 'true';
      }
    });
    root.querySelectorAll('.product-variants').forEach(block => {
      const unresolved = block.querySelectorAll('[data-cf-unresolved="true"]').length;
      let more = block.querySelector('.product-variants__more');
      const baseCount = Number(block.dataset.extraColors || 0);
      const count = baseCount + unresolved;
      if (count && !more) {
        more = document.createElement('a');
        more.className = 'product-variants__more';
        more.href = block.dataset.productUrl;
        block.appendChild(more);
      }
      if (more) more.textContent = '+' + count + ' ' + (block.dataset.moreLabel || 'more');
    });
  }

  function showPreview(swatch) {
    const card = swatch.closest('[data-cf-product-card]');
    const preview = card?.querySelector('.cf-variant-preview');
    if (!preview) return;
    const url = swatch.dataset.variantImage;
    preview.hidden = true;
    preview.dataset.pendingImage = url || '';
    if (!url) return;
    preview.onload = () => {
      if (preview.dataset.pendingImage === url) preview.hidden = false;
    };
    preview.onerror = () => { preview.hidden = true; };
    preview.src = url;
    if (preview.complete && preview.naturalWidth > 0) preview.hidden = false;
  }

  function hidePreview(block) {
    const preview = block.closest('[data-cf-product-card]')?.querySelector('.cf-variant-preview');
    if (preview) {
      preview.dataset.pendingImage = '';
      preview.hidden = true;
    }
  }

  // Delegation works for newly appended or filter-replaced cards without rebinding.
  document.addEventListener('pointerover', event => {
    if (event.pointerType === 'touch') return;
    const swatch = event.target.closest('.cf-color-swatch');
    if (swatch && !swatch.contains(event.relatedTarget)) showPreview(swatch);
  });
  document.addEventListener('pointerout', event => {
    const block = event.target.closest('.product-variants');
    if (block && !block.contains(event.relatedTarget)) hidePreview(block);
  });
  document.addEventListener('focusin', event => {
    const swatch = event.target.closest('.cf-color-swatch');
    if (swatch) showPreview(swatch);
  });
  document.addEventListener('focusout', event => {
    const block = event.target.closest('.product-variants');
    if (block && !block.contains(event.relatedTarget)) hidePreview(block);
  });

  function start() {
    paintSwatches();
    let queued = false;
    const observer = new MutationObserver(records => {
      const hasCards = records.some(record => Array.from(record.addedNodes).some(node =>
        node.nodeType === 1 && (node.matches('[data-cf-product-card], #AjaxinateContainer, #AjaxinatePagination') ||
          node.querySelector('[data-cf-product-card], #AjaxinateContainer, #AjaxinatePagination'))
      ));
      if (!hasCards || queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        paintSwatches();
          });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });
})();